<sd-6-17-1-dialog
  #dialog
  class="image-export"
  [headline]="'dashboard.imageExport.title' | transloco: { format: format() }"
  (afterHide)="onAfterHide()">
  <div class="image-export-dialog">
    <sd-6-17-1-input
      #nameInput
      lang="de"
      size="md"
      [label]="'dashboard.imageExport.fileName' | transloco"
      [value]="fileName()"></sd-6-17-1-input>

    @if (filterLabels().length > 0) {
      <div class="filter-pills">
        <span class="filter-pills-heading">{{ 'dashboard.imageExport.activeFilters' | transloco }}</span>
        @for (label of filterLabels(); track $index) {
          <span class="filter-pill">{{ label }}</span>
        }
      </div>
    }

    <div class="preview">
      @if (previewUrl(); as url) {
        <img
          [src]="url"
          [alt]="'dashboard.imageExport.previewAlt' | transloco" />
      }
    </div>

    @if (errorMessage(); as error) {
      <p class="error-message">{{ error }}</p>
    }

    <div class="dialog-actions">
      @if (clipboardAvailable) {
        <sd-6-17-1-button
          variant="secondary"
          type="button"
          [disabled]="busy()"
          (click)="copy()">
          {{ 'dashboard.imageExport.copy' | transloco }}
        </sd-6-17-1-button>
      }
      <sd-6-17-1-button
        class="download-button"
        wctLoadingIndicator
        [apiCallAdditionalLoading]="busy"
        variant="primary"
        type="button"
        [disabled]="!canDownload"
        (click)="download()">
        {{ 'dashboard.imageExport.download' | transloco: { format: format() } }}
      </sd-6-17-1-button>
    </div>
  </div>
</sd-6-17-1-dialog>
